(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name FormlySettingsPanelWrapper
     * @module thismoment.common.formly.wrapper
     *
     * @description
     * Changes the formly template for panels to allow a single form to have
     * many different collapsible panels with their own heading
     */

  require('./scss/settings-panel.scss')

  var MODULE_NAME = 'thismoment.common.formly.wrappers.settings-panel'
  var templateUrl = require('./tpl/settings-panel.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-ui-bootstrap/src/accordion')

    ])
    .run(settingsPanelWrapperConfig)

  settingsPanelWrapperConfig.$inject = ['formlyConfig']
  function settingsPanelWrapperConfig (formlyConfig) {
    formlyConfig.setWrapper({
      name: 'panel',
      templateUrl: templateUrl
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/wrappers/settings-panel.js